import { Identity } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { Transport } from '../model/Transport';
import { EntranceRegistration } from '../model/out/entrance-registration';
import { map } from 'rxjs/operators';
import { AreaGate } from '../model/areaGate';

@Injectable({
  providedIn: 'root'
})
export class RegisterEntranceService {

  getAreaGates() {
    return this.appServerAPI.execute<AreaGate[]>(`/client/control/transport/register/entrance/area-gates`, {}).pipe(map(response => {
      const gates = new Array<AreaGate>();
      for (const entry of response) {
        gates.push(new AreaGate(entry));
      }
      return gates;
    }));
  }

  constructor(private appServerAPI: AppServerAPI) { }

  getTransport(identity: Identity): Observable<Transport> {
    return this.appServerAPI.execute<Transport>(`/client/control/transport/register/entrance/transport`, identity);
  }

  accept(identity: EntranceRegistration): Observable<any> {
    return this.appServerAPI.execute<any>(`/client/control/transport/register/entrance/accept`, identity);
  }

  decline(identity: EntranceRegistration) {
    return this.appServerAPI.execute<any>(`/client/control/transport/register/entrance/decline`, identity);
  }
}
